import * as React from "react";
import { Button, KIND } from "baseui/button";
import { useStyletron, styled } from "baseui";
import { MainContainer, InputContainer, LogoContainer, FormContainer } from "./LoginStyles";
import templizeLogo from '../../../images/templize-logo.svg'; // Import the logo

const StyledLink = styled("a", ({ $theme }) => ({
  textDecoration: "none",
  color: $theme.colors.primary,
  cursor: "pointer",
  ":hover": {
    textDecoration: "underline",
  },
}));

function AuthForm({ children, error, isLoading }) {
  const [css, theme] = useStyletron();

  return (
    <MainContainer 
    flexGridColumnGap="scale800"
    flexGridRowGap="scale800"
    flexGridColumnCount={1} >
        <FormContainer>
      <LogoContainer>
        <img src={templizeLogo} alt="Templize Logo" />
        </LogoContainer>
      <InputContainer>
        {children}
        {error && (
          <div
            className={css({
              color: theme.colors.negative,
              marginBottom: theme.sizing.scale600,
            })}
          >
            {error}
          </div>
        )}
      </InputContainer>
      </FormContainer>
    </MainContainer>
  );
}

export { AuthForm, StyledLink };
